import styleInject from 'style-inject';

var css_248z = ".ThemeSelect-module_radioButton__PZ057.ThemeSelect-module_radioButton__PZ057 {\n\tmargin-right: 40px;\n\tdisplay: flex;\n}\n\n.ThemeSelect-module_radioButton__PZ057.ThemeSelect-module_radioButton__PZ057 input + span {\n\tbackground-color: var(--qd-color-radio-button-bg);\n}\n\n.ThemeSelect-module_container__2fwrt {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n}\n";
var styles = {"radioButton":"ThemeSelect-module_radioButton__PZ057","container":"ThemeSelect-module_container__2fwrt"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
